export const AllowedPaths: string[] = [
  '/claim-redeem-offer',
  '/subscription-center',
  '/sign-up',
];
